import React from 'react';
import { Box, makeStyles, Popover } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  popover: {
    marginTop: '-0.25rem',
    '& .MuiPaper-rounded': {
      borderRadius: '0.625rem !important',
    },
    '& .MuiPaper-root': {
      boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
    },
    '& .MuiPopover-paper': {
      overflow: 'unset',
    },
  },
  sanjiao: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -90%)',
    borderBottom: '0.7rem solid #fff',
    borderRight: '0.7rem solid transparent',
    borderLeft: '0.7rem solid transparent',
    borderTop: '0.7rem solid transparent',
  },
}));

export default function BottomPop({ id, anchorEl, closePop, children }) {
  const classes = styles();
  return (
    <Popover
      id={id}
      
      className={classes.popover}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={closePop}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box className={classes.root}>
        {children}
        <div className={classes.sanjiao} />
      </Box>
    </Popover>
  );
}
